import EventActionProto from 'core/gd-session/event-action-proto';
import SessionMeetingsCollection from "core/model2/meeting/session/session-meetings-collection";

module.exports = class SessionMeetingsReset extends EventActionProto {

    constructor(uid, data, sid, companyId) {
        super(uid, data, companyId);
    }

    process() {

        // never initialized
        if (!gd.session.meetings) {
            gd.session.meetings = new SessionMeetingsCollection(this.data);
        } else {
            gd.session.meetings.reset(this.data);
        }

        super.process();
    }
};

